/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationBranchModel } from '../../models/organization-branch-model';

export interface AdminFhirIdBranchesGet$Params {
  fhirId: string;
}

export function adminFhirIdBranchesGet(http: HttpClient, rootUrl: string, params: AdminFhirIdBranchesGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationBranchModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdBranchesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationBranchModel>>;
    })
  );
}

adminFhirIdBranchesGet.PATH = '/Admin/{fhirId}/Branches';
